<template>
  <ul class="sui-tabs" :class="tabClass" data-cy="tabs">
    <slot />
  </ul>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps({
  tabClass: {
    type: String,
    default: "",
  },
});
const { tabClass } = toRefs(props);
</script>

<style lang="scss" scoped>
.sui-tabs {
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 42px;
  margin: 0;
  padding: 0 8px;
  list-style: none;
  background-color: var(--color-bg-primary);
  border-radius: 4px;
}
</style>
